import React, { useMemo } from "react";
import { Button, Dropdown, Icon, Menu, message } from "antd";
import useRequestFn from "../../../../utils/useRequestFn";
import {
    CatchPhoto,
    updateCatchPhoto,
    updatePaperDownload,
    updatePhoneUpload
} from "../../../../service/exam";
import { errorMessage } from "../../../../service/service";

enum Type {
    updateCatchPhoto,
    updatePhoneUpload,
    updatePaperDownload
}

interface Props {
    examId: string;
    stuNos: string[];
    onOk: () => void;
    disabled: boolean;
}
const Index = ({ examId, stuNos, onOk, disabled }: Props) => {
    async function saveData(state: CatchPhoto, type: Type) {
        try {
            switch (type) {
                case Type.updateCatchPhoto:
                    await updateCatchPhoto(
                        String(examId),
                        state,
                        stuNos.join()
                    );
                    break;
                case Type.updatePaperDownload:
                    await updatePaperDownload(
                        String(examId),
                        state,
                        stuNos.join()
                    );
                    break;
                case Type.updatePhoneUpload:
                    await updatePhoneUpload(
                        String(examId),
                        state,
                        stuNos.join()
                    );
                    break;
            }
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const [onOpenAll, openStatus] = useRequestFn(async (type: Type) => {
        await saveData(CatchPhoto.open, type);
    });

    const [onCloseAll, closeStatus] = useRequestFn(async (type: Type) => {
        await saveData(CatchPhoto.close, type);
    });

    const menu = (
        <Menu>
            <Menu.Item key="0" onClick={() => onOpenAll(Type.updateCatchPhoto)}>
                全部开启抓拍
            </Menu.Item>
            <Menu.Item
                key="1"
                onClick={() => onCloseAll(Type.updateCatchPhoto)}>
                全部关闭抓拍
            </Menu.Item>
            <Menu.Item
                key="2"
                onClick={() => onOpenAll(Type.updatePhoneUpload)}>
                全部开启手机端提交附件
            </Menu.Item>
            <Menu.Item
                key="3"
                onClick={() => onCloseAll(Type.updatePhoneUpload)}>
                全部关闭手机端提交附件
            </Menu.Item>
            <Menu.Item
                key="4"
                onClick={() => onOpenAll(Type.updatePaperDownload)}>
                全部开启下载试卷
            </Menu.Item>
            <Menu.Item
                key="5"
                onClick={() => onCloseAll(Type.updatePaperDownload)}>
                全部关闭下载试卷
            </Menu.Item>
        </Menu>
    );

    const loading = useMemo(() => {
        const arr = [closeStatus.loading, openStatus.loading];
        return arr.some(i => i);
    }, [closeStatus.loading, openStatus.loading]);

    return (
        <Dropdown overlay={menu} disabled={disabled}>
            <Button loading={loading}>
                更多操作 <Icon type="down" />
            </Button>
        </Dropdown>
    );
};

export default Index;
